import { ContentAdd } from '@fs/zion-icon'
import { LayoutBand, Button, colors, H5, Paragraph, Separator } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useCollectionContextProvider } from '../../../../providers/collectionProvider/CollectionProvider'
import useAddNamesEntryPoint, { ADD_NAMES_ENTRY_POINTS } from '../../../../hooks/useAddNamesEntryPoint'
import useGroupSectionsRework from '../hooks/useGroupSectionsRework'
import NewGroupCard from './NewGroupCard'

/**
 * The card at the end of the names list that starts a group.
 *
 * Before the group sections rework it is "Create household", a single button; after it,
 * {@link NewGroupCard}. Delete this file's own card, and this switch, with the flag.
 *
 * @component
 * @returns {JSX.Element}
 */
const CreateHouseholdCard = () => {
  const [t] = useTranslation()
  const groupSectionsRework = useGroupSectionsRework()
  const { isReadOnlyCollection } = useCollectionContextProvider()
  const { open: handleAddPersonClick } = useAddNamesEntryPoint(ADD_NAMES_ENTRY_POINTS.BLANK_STATE)

  if (groupSectionsRework) return <NewGroupCard />

  return (
    <>
      <Separator size="xxs" />
      <LayoutBand color={colors.blue02} marginY="xxs">
        <H5>{t('create-household-card.title', 'Create household')}</H5>
        <Paragraph size="sm">
          {t(
            'create-household-card.description',
            'Not seeing a household from the record listed here yet? Create one now!'
          )}
        </Paragraph>
        <Separator size="nano" />
        <Button
          emphasis="medium"
          Icon={ContentAdd}
          onClick={() => handleAddPersonClick()}
          linkName="New Household"
          data-testid="new-household-button"
          disabled={isReadOnlyCollection}
          fullWidth
        >
          {t('create-household-card.button', 'New household')}
        </Button>
      </LayoutBand>
      <Separator size="xxs" />
    </>
  )
}

export default CreateHouseholdCard
